<template>
  <!-- 表格说明： 此表格主要为基本表格，且为最常用的表格，兼具基本表格的功能：复选框，编辑列，表格列中内容有点击事件-->
  <div
    class="table-content normalTableCont"
    :style="{ height: tableData.options.tableHeight + 'px' }"
  >
    <el-table
      :data="tableData.list"
      ref="multipleTableRef"
      border
      fit
      :max-height="tableData.options.tableHeight"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
      style="width: 100%"
    >
      <!-- 暂无数据提示，自己定义就OK了 -->
      <template slot="empty">
        <div class="empty-box">
          <i class="mh-kym_icon icon"></i>
          <p class="col-66 text-1">
            {{
              tableData.options.errortip != ""
                ? tableData.options.errortip
                : $t("components.Table.normalTableCont.50zeqpf84mw0")
            }}
          </p>
        </div>
      </template>
      <!-- //表格多选是否存在判断 -->
      <el-table-column
        v-if="tableData.options.mutiSelect && tableData.options.selectDisable"
        type="selection"
        align="center"
        style="width: 55px"
        :selectable="checkboxInit"
        fixed="left"
      ></el-table-column>
      <el-table-column
        v-else-if="tableData.options.mutiSelect && tableData.options.teacherDisable"
        type="selection"
        align="center"
        style="width: 55px"
        :selectable="checkboxInit3"
        fixed="left"
      ></el-table-column> 
      <el-table-column
        v-else-if="tableData.options.mutiSelect"
        type="selection"
        align="center"
        :selectable="checkboxInit2"
        style="width: 55px"
        fixed="left"
      ></el-table-column>
      <!-- 表格数据渲染 -->
      <template v-for="(column, $index) in tableData.columns">
        <!-- 固定列 -->
        <template
          v-if="$index == IndexId || $index == IndexIdTwo || $index == 0"
        >
          <el-table-column
            :prop="column.fieldstring"
            :key="$index"
            fixed="left"
            :sortable="column.sortable ? 'custom' : false"
            :label="column.fieldname"
            align="center"
            :min-width="column.width ? column.width : '150px'"
            :width="column.isShowWay == '1' ? '180px' : 'auto'"
            :show-overflow-tooltip="true"
            v-if="column.show == '1'"
          >
            <template slot-scope="scope">
              <el-button
                v-if="column.ismethod"
                type="text"
                class="link-type"
                @click="handleColumnChange(scope.$index, column, scope.row)"
                >{{
                  tableData.list[scope.$index][column.fieldstring]
                }}</el-button
              >
              <!-- 线上课和实体课的标识 -->
              <div v-else-if="column.isShowWay == '1'" class="show-hour-way">
                <i
                  v-if="scope.row.hour_way == '1'"
                  class="table-icon table-icon-xianshang"
                ></i>
                <i v-else class="table-icon table-icon-shiti"></i>
                <span v-html="scope.row[column.fieldstring]"></span>
              </div>
              <span
                v-else
                type="text"
                v-html="tableData.list[scope.$index][column.fieldstring]"
              ></span>
            </template>
          </el-table-column>
        </template>
        <!-- 一般列 -->
        <template v-else>
          <el-table-column
            :prop="column.fieldstring"
            :key="$index"
            :label="column.fieldname"
            :sortable="column.sortable ? 'custom' : false"
            align="center"
            :min-width="column.width ? column.width : '150px'"
            :width="column.isShowWay == '1' ? '180px' : 'auto'"
            :show-overflow-tooltip="true"
            v-if="column.show == '1'"
          >
            <template slot-scope="scope">
              <el-button
                v-if="column.ismethod"
                type="text"
                class="link-type"
                @click="handleColumnChange(scope.$index, column, scope.row)"
                >{{
                  tableData.list[scope.$index][column.fieldstring]
                }}</el-button
              >
              <!-- 线上课和实体课的标识 -->
              <div v-else-if="column.isShowWay == '1'" class="show-hour-way">
                <i
                  v-if="scope.row.hour_way == '1'"
                  class="table-icon table-icon-xianshang"
                ></i>
                <i v-else class="table-icon table-icon-shiti"></i>
                <span v-html="scope.row[column.fieldstring]"></span>
              </div>
              <span
                v-else
                type="text"
                v-html="tableData.list[scope.$index][column.fieldstring]"
              ></span>
            </template>
          </el-table-column>
        </template>
      </template>
      <!-- 操作列 -->
      <slot></slot>
      <!-- 编辑列 -->
      <el-table-column
        fixed="right"
        label
        align="center"
        width="40px"
        v-if="tableData.options.issetting"
        :render-header="renderHeader"
      ></el-table-column>
    </el-table>
    <!-- 穿梭框 -->
    <el-dialog
      :title="$t('components.Table.normalTableCont.50zeqpf87io0')"
      class="setting-box"
      :visible.sync="dialogVisible"
      width="520px"
    >
      <el-transfer
        v-model="oprateColumn"
        :data="data"
        :titles="[
          $t('components.Table.normalTableCont.50zeqpf88380'),
          $t('components.Table.normalTableCont.50zeqpf88lo0'),
        ]"
      ></el-transfer>
      <div class="oprate">
        <el-button size="small" type="primary" @click="handSetting()">{{
          $t("components.Table.normalTableCont.50zeqpf894w0")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "normalTableCont",
  props: {
    // 表格数据所有参数
    tableData: {
      type: Object,
    },
  },
  data() {
    return {
      dialogVisible: false,
      showColumns: [],
      data: [],
      oprateColumn: [], //编辑列
      IndexId: -1, //固定的列数
      IndexIdTwo: -1, //固定的列数
    };
  },
  created() {
    this.getColums();
    this.toggleSelection(this.tableData.multipleTable);
  },
  watch: {
    getIndex(n, o) {
      var i = 0;
      var _index = 0,
        _index_two = 0;
      if (n.length >= 8) {
        n.forEach((item, index) => {
          if (item.show == "1" && i == 0) {
            i++;
            _index = index;
          } else if (item.show == "1" && i == 1) {
            i++;
            _index_two = index;
          }
        });
        this.IndexId = _index;
        this.IndexIdTwo = _index_two;
      }
      // 编辑列操作
      if (this.tableData.options.issetting) {
        var fieldColumns = n;
        if (
          !this.$Tool.getStorage("module" + [this.tableData.options.moduleName])
        ) {
          this.$Tool.setStorage(
            "module" + [this.tableData.options.moduleName],
            {}
          );
        }
        var obj = this.$Tool.getStorage(
          "module" + [this.tableData.options.moduleName]
        );
        obj["all_" + [this.tableData.options.ColumnName]] = n;
        // obj["show_" + [this.tableData.options.ColumnName]] = n;
        this.$Tool.setStorage(
          "module" + [this.tableData.options.moduleName],
          obj
        );
        if (obj["show_" + [this.tableData.options.ColumnName]]) {
          fieldColumns = obj["show_" + [this.tableData.options.ColumnName]];
        }
        // 自定义编辑列
        var settingOprateData = this.$Common.settingOprateData(fieldColumns);
        this.data = settingOprateData.data;
        this.oprateColumn = settingOprateData.oprateColumn;
      }
    },
    getmultipleTable(n, o) {
      this.toggleSelection(n);
    },
  },
  computed: {
    getIndex() {
      return this.tableData.columns;
    },
    getmultipleTable() {
      return this.tableData.multipleTable;
    },
  },
  methods: {
    getColums() {
      var i = 0;
      var _index = 0,
        _index_two = 0;
      if (this.tableData.columns.length >= 8) {
        this.tableData.columns.forEach((item, index) => {
          if (item.show == "1" && i == 0) {
            i++;
            _index = index;
          } else if (item.show == "1" && i == 1) {
            i++;
            _index_two = index;
          }
        });
        this.IndexId = _index;
        this.IndexIdTwo = _index_two;
      }
    },
    // 复选框控制权限
    checkboxInit(row, index) {
      if (
        (row.isFromStudentGoods == "true" &&
          row.erpgoods_isfree == "0" &&
          row.erpgoods_isreceive == "0") ||
        (row.hour_ischecking &&
          row.hour_ischecking != 1 &&
          row.hour_ischecking != -1)
      ) {
        // hour_ischecking  上课状态 1已上课 -1已取消
        return 1; //可勾选
      } else {
        return 0; //不可勾选
      }
    },
    checkboxInit3(row, index) {
      if (
        row.school_id == this.$userinfo.SCHOOL_ID &&
        ((row.isFromStudentGoods == "true" &&
          row.erpgoods_isfree == "0" &&
          row.erpgoods_isreceive == "0") ||
          (row.hour_ischecking &&
            row.hour_ischecking != 1 &&
            row.hour_ischecking != -1))
      ) {
        // hour_ischecking  上课状态 1已上课 -1已取消
        return 1; //可勾选
      } else {
        return 0; //不可勾选
      }
    },
    checkboxInit2(row, index) {
      return (
        row.absence_status != -2 &&
        row.absence_status != -1 &&
        (row.is_revoke || row.absence_status != 1)
      );
    },
    // 编辑列渲染
    renderHeader(h, { column, $index }) {
      return h("i", {
        class: "el-icon-setting btn-setting",
        on: {
          click: () => {
            this.dialogVisible = true;
          },
        },
      });
    },
    // 表格内容绑定事件
    handleColumnChange(k, v, column) {
      this.$emit("handleColumnChange", k, v, column);
    },
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    // 编辑列提交
    handSetting() {
      let obj = this.$Tool.getStorage(
        "module" + [this.tableData.options.moduleName]
      );
      let allnum = obj["all_" + [this.tableData.options.ColumnName]];
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item, index) => {
        allnum[parseInt(item)].show = "0";
      });
      this.showColumns = allnum;
      obj["show_" + [this.tableData.options.ColumnName]] = this.showColumns;
      this.$Tool.setStorage(
        "module" + [this.tableData.options.moduleName],
        obj
      );
      this.$emit("handSetting", this.showColumns);
      this.dialogVisible = false;
    },
    // 多选默认选中的状态
    toggleSelection(rows) {
      //   是否默认选中
      if (this.tableData.options.mutiSelect && rows && rows.length > 0) {
        let multipleInfoData = this.tableData.multipleTable;
        this.$nextTick(() => {
          rows.forEach((row) => {
            multipleInfoData.forEach((item, index2) => {
              if (row.student_id == item.student_id) {
                this.$refs.multipleTableRef.toggleRowSelection(row, true);
              }
            });
          });
        });
      } else {
        this.clear();
      }
    },
    // 多选清除选中的状态
    clear() {
      this.$nextTick(() => {
        this.$refs.multipleTableRef.clearSelection();
      });
    },
    // 排序 - 后台排序
    sortChange(column, prop, order) {
      this.$emit("sortChange", column);
    },
  },
};
</script>
<style lang="less">
.normalTableCont {
  .btn-setting {
    display: block;
    width: 20px;
    height: 20px;
    font-size: 16px;
    margin: 0 auto;
    color: #aaa;
    // background-color: green;
    cursor: pointer;
  }
  .setting-box {
    .el-transfer__buttons {
      .el-transfer__button {
        width: 30px !important;
        height: 30px !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        margin: 0 auto 10px !important;
        padding: 10px;
        border-radius: 50%;
      }
    }
  }
}
</style>
